import config from '@/config'
export  default [
  // {
  //   title: "媒体组件",
  //   modules: [
  //     {
  //       icon: "FundOutlined",
  //       name: "轮播图",
  //       type:'banner',
  //       defaultData:{
  //         type:'banner',
  //         name:'图片轮播',
  //         data:[
  //           {imgUrl:'',linkType:'',linkUrl:""},
  //         ],
  //         params:{
  //           interval: "2800"
  //         },
  //         style:{
  //           btnColor: "#ffffff",
  //           btnShape: "round"
  //         }
  //       }
  //     },
  //     {
  //       icon: "WindowsOutlined",
  //       name: "图片橱窗",
  //       type:'windows',
  //       defaultData:{
  //         type:'windows',
  //         name:'图片橱窗',
  //         data:[
  //           {imgUrl:"",linkType:'',linkUrl:""},
  //         ],
  //         params:{
  //           interval: "2800"
  //         },
  //         style:{
  //           class:'full',
  //           backgroundColor: "#ffffff",
  //           paddingTB:0,
  //           paddingLR:0,
  //         }
  //       }
  //     }
  //   ]
  // },
  {
    title: "商城组件",
    modules: [
      {
        icon: "FileTextOutlined",
        name: "会员任务",
        type:'task',
        defaultData:{
          type:'task',
          name:'会员任务',
          // data:[
          //   {name:'',describe:'',imgUrl:"",linkType:'',linkUrl:""}
          // ],
          params:{},
          style:{
            taskTitle: '会员任务',
            color:'#EFC58D',
            bgColor:{
              left:'#303145',
              right:'#44495E'
            },
          }
        }
      },
      {
        icon: "FileTextOutlined",
        name: "礼品分享",
        type:'share',
        hidden:true,
        defaultData:{
          type:'share',
          name:'礼品分享',
          data:[],
          params:{},
          style:{
            shareTitle: '礼品分享',
            color:'#EFC58D',
            bgColor:{
              left:'#303145',
              right:'#44495E'
            },
          }
        }
      },
      {
        icon: "FileTextOutlined",
        name: "礼品领取",
        type:'receive',
        hidden:true,
        defaultData:{
          type:'receive',
          name:'礼品领取',
          data:[],
          params:{},
          style:{
            receiveTitle: '礼品领取',
            color:'#EFC58D',
            bgColor:{
              left:'#303145',
              right:'#44495E'
            },
          }
        }
      },
      {
        icon: "FileTextOutlined",
        name: "会员卡组件配置",
        type:'assets',
        hidden:true,
        defaultData:{
          type:'assets',
          name:'会员卡组件配置',
          data:[
            {name:'积分',show:true},{name:'卡券',show:true},{name:'红包',show:true},
          ],
          params:[
            { name: '生日礼包', imgUrl: ""}, 
            { name: '免邮特权', imgUrl: "",hidden:true }, 
            { name: '产品特权', imgUrl: ""}, 
            { name: '扫码特权', imgUrl: ""}, 
            { name: '折扣特权', imgUrl: ""}
          ],
          style:{
            color:'#EFC58D',
            bgColor:{
              left:'#303145',
              right:'#44495E'
            },
            assetsBgColor:'#484D62',
            show: true,
            privilegeTitle: '会员权益'
          }
        }
      },
      {
        icon: "FileTextOutlined",
        name: "功能模块",
        type:'module',
        hidden:true,
        defaultData:{
          type:'module',
          name:'功能模块',
          data:[
            { name: '我的奖品', imgUrl: "",checkout:true,show:true,disabled:true }, 
            { name: '扫码奖品', imgUrl: "",checkout:true,show:true,disabled:true },
            { name: '订单', imgUrl: "",checkout:true,show:true,disabled:true },  
            // { name: '云店', imgUrl: "",checkout:true,show:true },  
            { name: '积分商城', imgUrl: "",checkout:true,show:true },
            // { name: '权益卡', imgUrl: "",checkout:true,show:true }
          ],
          params:{},
          style:{
            show:false,
            moduleTitle:'功能模块',
            color:'#EFC58D',
            bgColor:{
              left:'#303145',
              right:'#44495E'
            },
          }
        }
      }
    ],
  }
]